export const BASE_TEXT_COLOR = '#ffffff'

export enum BG_COLOR_VARIANT {
  RED = 'rgb(255, 0, 0)',
  ORANGE = 'rgb(255, 153, 0)',
  YELLOW = 'rgb(255, 255, 0)',
  GREEN = 'rgb(0, 255, 0)',
  CYAN = 'rgb(0, 255, 255)',
  BLUE = 'rgb(74, 134, 232)',
  DARK_BLUE = 'rgb(0, 0, 255)',
  PURPLE = 'rgb(153, 0, 255)',
  PINK = 'rgb(255, 0, 255)',
}

export enum FG_COLOR_VARIANT {
  RED = 'rgb(255, 0, 0)',
  ORANGE = 'rgb(255, 153, 0)',
  YELLOW = 'rgb(255, 255, 0)',
  GREEN = 'rgb(0, 255, 0)',
  CYAN = 'rgb(0, 255, 255)',
  BLUE = 'rgb(74, 134, 232)',
  DARK_BLUE = 'rgb(0, 0, 255)',
  PURPLE = 'rgb(153, 0, 255)',
  PINK = 'rgb(255, 0, 255)',
}
